import React from 'react'
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom'

interface LinkProps extends RouterLinkProps {
  children: React.ReactNode
  removeTextDecoration?: boolean
}

const Link: React.FC<LinkProps> = ({ children, removeTextDecoration, style: userStyle, ...props }) => {
  const style = {
    textDecoration: removeTextDecoration ? 'none' : 'inherit',
    ...userStyle
  }
  return (
    <RouterLink style={style} {...props}>
      {children}
    </RouterLink>
  )
}

export default Link
